import React from 'react'
import Link from 'redux-first-router-link'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { SETTINGS_WIDGET_CREATE_NEW_PAGE } from 'subapps/settings/types'
import StartContent from 'components/StartContent'
import liveChat from 'assets/livechat-generic.png'
import { styles } from './styles'

const EmptyPage = () => {
  return (
    <div css={styles.container}>
      <div css={styles.innerContainer}>
        <StartContent
          title="Live chat support made simple"
          subtitle="Offer support on any page of your website or app with your very own Live Chat widget."
          css={styles.content}
        >
          <div css={[text.styles.textSm, text.styles.fontSemibold]}>
            Setup time of 5 minutes or less.
          </div>
          <Button
            as={Link}
            css={styles.btn}
            type="info"
            size="xBig"
            to={{
              type: SETTINGS_WIDGET_CREATE_NEW_PAGE,
            }}
          >
            Get started with chat
          </Button>
        </StartContent>
        <div css={styles.imgWrapper}>
          <img src={liveChat} alt="Empty" />
        </div>
      </div>
    </div>
  )
}

export default EmptyPage
